// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__bqKfw","searchForm":"search_searchForm__ElyTU"};